import { Button, Modal } from "antd";
import React, { useState } from "react";
import isEqual from "react-fast-compare";
import {
  setDeletePostFlag,
  setScreenDeepDiveData,
  setScreenUpdatedData,
} from "../../../redux/actions/commandCenter/screens/screen";
import { useDispatch, useSelector } from "react-redux";
import { deletePostFromTool } from "../../../redux/actions/commandCenter/commandCenterApi";
import { getDeepDive } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setDeepDiveInfoLoader,
  setMentionPageInnerTabs,
} from "../../../redux/actions/DeepDive";
import { setDeepDiveObject } from "../../../redux/actions/WidgetMaker/WidgetMaker";
const DeletePost = ({ isOpen, setDeletePost, deletePost, deepDive }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const screen = useSelector((state) => state?.Screens?.screen);
  const infoBarObject = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const mentions_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const deepdive_object = useSelector(
    (state) => state.WidgetMaker.deepdive_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const tabClick = useSelector((state) => state.DeepDive.tabClick);

  const handleDeletePostCancel = () => {
    setDeletePost({
      modalShow: false,
      data: null,
    });
  };

  const handleDeletePost = () => {
    let postData = deletePost?.data;
    // console.log("handleDeletePost", postData);
    let payloadObject = {
      brandFriendlyName: postData?.BrandFriendlyName,
      brandID: postData?.PostBrandID,
      brandName: postData?.BrandName,
      ChannelType: postData?.channel_type,
      ContentId: postData?.PostContentID,
      TagId: postData?.TagID
        ? postData?.TagID
        : postData?.TagId
        ? postData?.TagId
        : postData?.tagid,
      deepDive: deepDive,
    };

    if (tabClick?.tabName === "influencers") {
      delete influencers_object.deepdive_on.order_by;
      delete influencers_object.filter_by_data;
      influencers_object.filter_by = null;
    }
    let mention_obj = {
      screen: screen,
      shareBrands: shareBrands,
      shareTemplateData: shareTemplateData,
      mentions_object: mentions_object,
      authParams: authParams,
      markInfluencerFlag: true,
      infoBarObject: infoBarObject,
      deepdive_object: deepdive_object,
      selectedTabName: tabClick?.tabName,
      influencers_object: influencers_object,
    };
    dispatch(deletePostFromTool(payloadObject, mention_obj));
    setDeletePost({
      modalShow: false,
      data: null,
    });

    if (deepDive) {
      if (tabClick?.tabName === "mentions") {
        dispatch(setMentionPageInnerTabs(true));
      } else if (tabClick?.tabName === "influencers") {
        dispatch(setDeepDiveInfoLoader(true));
      }

      dispatch(setDeletePostFlag(true));
    } else if (authParams?.screen_id === "000-000-555") {
      mentionChartApiCall();
    }
  };

  const mentionChartApiCall = () => {
    let selectedPost = deletePost?.data;

    let screenData = { ...screen };
    let updatedScreenWidgets = screenData?.widgets?.length
      ? screenData?.widgets
      : [];

    let selectedWidget = updatedScreenWidgets?.find(
      (d) => d?.widget_id === "000-100-974"
    );
    // console.log("selectedWidget", selectedWidget);

    let updatedWidgetData = selectedWidget?.graphData
      ? selectedWidget?.graphData?.data?.[`custom-card`]?.[0]?.data?.filter(
          (d) => d?.tagid !== selectedPost?.tagid
        )
      : selectedWidget?.persist_graphdata?.data?.[
          `custom-card`
        ]?.[0]?.data?.filter((d) => d?.tagid !== selectedPost?.tagid);
    // console.log("updatedWidgetData ===>", updatedWidgetData);

    updatedScreenWidgets = updatedScreenWidgets?.map((d) => {
      if (d?.widget_id === "000-100-974") {
        d.deletedTagId = selectedPost?.tagid;
        d.graphData.data[`custom-card`][0].data = updatedWidgetData;
        d.persist_graphdata.data[`custom-card`][0].data = updatedWidgetData;
      }
      if (d?.widget_id === "000-100-976") {
        d.graphData = null;
      }
      return d;
    });

    // console.log("updatedScreenWidgets", updatedScreenWidgets);
    screenData = {
      ...screenData,
      widgets: updatedScreenWidgets?.length ? updatedScreenWidgets : [],
    };
    dispatch(setScreenUpdatedData(screenData));
  };

  const handleInforBarDeepdive = (e, data) => {
    dispatch(
      setScreenDeepDiveData(
        null,
        screen,
        "info-bar",
        null,
        shareBrands,
        shareTemplateData
      )
    );
    let widget_ids = ["info-bar"];
    let info_bar_object = {
      ...infoBarObject,
      tabName: "info-bar",
      screen: screen,
    };

    dispatch(getDeepDive(authParams, info_bar_object, widget_ids));
  };
  return (
    <>
      <Modal
        title=""
        open={isOpen}
        style={{
          top: 100,
        }}
        // mask={false}
        footer={null}
        closable={false}
        className="stream__closeModal"
      >
        <div class="stream__closeModal--tickIcon">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <div
          style={{ fontSize: "1.8rem" }}
          className="stream__closeModal--title text-center"
        >
          Do you want to delete{" "}
          <b>
            {deletePost?.data?.Author
              ? deletePost?.data?.Author
              : deletePost?.data?.AuthorName}
            's
          </b>{" "}
          post from locobuzz ?
          <div className="text_regular" style={{ color: "#ff6666" }}>
            *The post will be deleted from Locobuzz only, not from Social.
          </div>
        </div>
        <div className="d-flex align-items-center stream__closeModal--btns">
          <Button
            className="command__center--primaryBtn"
            onClick={handleDeletePostCancel}
          >
            No
          </Button>
          <Button
            className="command__center--secondaryBtn"
            onClick={handleDeletePost}
          >
            Yes
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(DeletePost, isEqual);
